import React from 'react';
import { FastField, Form, Formik, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import Done from '@mui/icons-material/Done';
import { Box, Typography } from '@mui/material';
import CommonPasswordFields from '../../account/CommonPasswordFields';
import RenderTextField from '../../common/RenderTextField';
import Button from '../../common/Button';
import AgreeToTermsInfo from '../../terms/AgreeToTermsInfo';
import { passwordValidator, validateRequiredEmail } from '../../../utils/validators';

const OnboardingVerificationForm = ({ onSubmit, initialValues }) => (
  <Formik
    initialValues={{ ...initialValues, password: '', repeatPassword: '' }}
    validate={(values) => {
      const errors = {};
      const emailError = validateRequiredEmail(values.email);
      const passwordError = passwordValidator(values.password, values.repeatPassword);

      if (emailError) {
        errors.email = emailError;
      }
      if (passwordError.password) {
        errors.password = passwordError.password;
      }
      if (passwordError.repeatPassword) {
        errors.repeatPassword = passwordError.repeatPassword;
      }

      return errors;
    }}
    onSubmit={onSubmit}
    validateOnChange={true}
    validateOnBlur={true}
  >
    {({ isSubmitting, handleSubmit, values }) => (
      <Form onSubmit={handleSubmit}>
        <FastField
          disabled
          name="email"
          label="Email"
          component={RenderTextField}
          type="text"
        />
        <ErrorMessage name="email" component={Typography} color="error" />

        <CommonPasswordFields
          password={values.password}
          repeatPassword={values.repeatPassword}
        />

        <Box sx={{ mt: 2 }}>
          <Button
            color="primary"
            type="submit"
            iconOnRight={true}
            label="Potwierdź"
            disabled={isSubmitting}
          />
        </Box>
      </Form>
    )}
  </Formik>
);

OnboardingVerificationForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

export default OnboardingVerificationForm;